import React from "react";
import { NavLink } from "react-router-dom";
// import { GridLoader } from 'react-spinners';
// import { NotificationManager } from 'react-notifications';
import * as moment from "moment";

import DatePicker from "react-datepicker";

import BootstrapTable from "react-bootstrap-table-next";

import paginationFactory from "react-bootstrap-table2-paginator";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import "react-notifications/lib/notifications.css";

import * as webLogsActions from "../../../store/admin";

import { GridLoader } from "react-spinners";

import { css } from "@emotion/core";

import { bindActionCreators } from "redux";

import { ExportXlsxCsv } from "./export-xlsx-csv";

import { connect } from "react-redux";

import * as _ from "lodash";

import { utilService } from "../../../common/utils";

import { config } from "../../../config/config";

import { deviceDetect } from "react-device-detect";

const override = css`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

class WebLogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLogsCsvData: [],
      filterData: {
        platform_logs: {},
        page_logs: {},
        users_logs: {},
      },
      isLoading: false,
      isFitering: false,
      errors: {
        platform_logs: {},
        page_logs: {},
        users_logs: {},
      },
    };
  }

  componentDidMount() {
    let device = deviceDetect();
    let osName = utilService.getOsName(device);
    let browserName = utilService.getBrowserName(device);
    let pageLogsData = {
      ipstack_access_key: config.ipstack_access_key,
      pageId: "web-logs",
      title: "Web Logs",
      browserName: browserName,
      osName: osName,
      pageType: "Web Logs Page",
      visited_at: new Date(),
      country_name: this.props.user.country_name,
      users_userid: this.props.user.userUid,
      users_username: this.props.user.username,
      users_firstname: this.props.user.firstname,
      users_lastname: this.props.user.surname,
    };
    // save page logs
    this.props.savePageVisitLogs({
      token: this.props.token,
      data: pageLogsData,
    });

    this.props.getPageVisitLogs({
      token: this.props.token,
      params: "?log_type=platform_logs",
    });
  }

  /**
   * It is a method which is invoked after a component is instantiated as well as
   * when it receives new props
   * @param {*} nextProps : Getting new props from reducer
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    // set csv data for page logs
    if (nextProps.pageLogs && nextProps.pageLogs.length > 0) {
      if (nextProps.pageLogs !== this.props.pageLogs) {
        let data = nextProps.pageLogs;
        let pageLogsCsvData = [];
        data.forEach((item, index) => {
          let data = {};
          if (item["publish_start"]) {
            if (
              item["publish_start"] === "UNPUBLISHED" ||
              item["publish_start"] === "INDEFINITE"
            ) {
              data["LiveFrom"] = item["publish_start"];
            } else {
              data["LiveFrom"] = moment(item.publish_start).format(
                "YYYY-MM-DD hh:mm a"
              );
            }
          } else {
            data["LiveFrom"] = "";
          }

          if (item["publish_end"]) {
            if (
              item["publish_end"] === "UNPUBLISHED" ||
              item["publish_end"] === "INDEFINITE"
            ) {
              data["LiveTo"] = item["publish_end"];
            } else {
              data["LiveTo"] = moment(item.publish_end).format(
                "YYYY-MM-DD hh:mm a"
              );
            }
          } else {
            data["LiveTo"] = "";
          }
          data["PostUid"] = item["postUid"];
          data["Title"] = item["title"];
          data["PageType"] = item["pageType"] ? item["pageType"] : "";
          data["VisitCount"] = item["visit_count"];
          pageLogsCsvData.push(data);
        });
        this.setState({
          pageLogsCsvData: pageLogsCsvData,
        });
      }
    }
  }

  handleDateChange(date, name, log_type) {
    let fields = this.state.filterData[log_type];
    fields[name] = date;
    this.setState({
      fields,
    });
  }

  onInputChange(log_type, e) {
    const { name, value } = e.target;
    let fields = this.state.filterData[log_type];
    fields[name] = value;
    this.setState({
      fields,
    });
  }

  onClickAccordion(log_type, e) {
    console.log(log_type);
    console.log(e);
    this.props.getPageVisitLogs({
      token: this.props.token,
      params: "?log_type=" + log_type,
    });
    this.setState({
      filterData: {
        platform_logs: {},
        page_logs: {},
        users_logs: {},
      },
      errors: {
        platform_logs: {},
        page_logs: {},
        users_logs: {},
      },
    });
  }

  onFilter(log_type, e) {
    e.preventDefault();
    console.log(log_type);
    console.log(e);
    if (this.validateForm(log_type)) {
      let fields = this.state.filterData[log_type];
      console.log(fields);
      let params = "?log_type=" + log_type;
      if (fields["visit_from_date"]) {
        params = params + "&";
        params =
          params +
          `visit_from_date=${moment(fields["visit_from_date"]).format(
            "YYYY-MM-DD"
          )}&visit_to_date=${moment(fields["visit_to_date"]).format(
            "YYYY-MM-DD"
          )}`;
      }
      if (fields["title"]) {
        params = params + "&";
        params = params + `post_title=${fields["title"]}`;
      }
      if (fields["users_userid"]) {
        params = params + "&";
        params = params + `users_userid=${fields["users_userid"]}`;
      }
      this.props.getPageVisitLogs({
        token: this.props.token,
        params: params,
      });
    }
  }

  onReset(log_type, e) {
    e.preventDefault();
    this.setState({
      filterData: {
        platform_logs: {},
        page_logs: {},
        users_logs: {},
      },
      isLoading: true,
      isFitering: false,
      isReseting: true,
      errors: {
        platform_logs: {},
        page_logs: {},
        users_logs: {},
      },
    });
    this.myFormRef.reset();
    this.props.getPageVisitLogs({
      token: this.props.token,
      params: "?log_type=" + log_type,
    });
  }

  validateForm(log_type) {
    let fields = this.state.filterData[log_type];
    let errors = this.state.errors;
    errors[log_type] = {};
    let formIsValid = true;

    if (fields["visit_from_date"] && !fields["visit_to_date"]) {
      formIsValid = false;
      errors[log_type]["visit_to_date"] = "*Please select To Date.";
    }
    if (fields["visit_to_date"] && !fields["visit_from_date"]) {
      formIsValid = false;
      errors[log_type]["visit_from_date"] = "*Please select From Date.";
    }

    if (fields["visit_to_date"] < fields["visit_from_date"]) {
      formIsValid = false;
      errors[log_type]["visit_to_date"] = "*Please select valid date.";
    }
    this.setState({
      errors: errors,
    });
    return formIsValid;
  }

  render() {
    const { osLogs, browserLogs, countryLogs, pageLogs, userLogs } = this.props;

    // const groupByPageLogs = _.groupBy(userLogs, 'postUid');
    // console.log(pageLogs);
    const osLogsColumns = [
      {
        dataField: "osName",
        text: "OS Name",
      },
      {
        dataField: "percentage",
        text: "Percentage",
        formatter: percentageFormatter,
      },
    ];

    const browserLogsColumns = [
      {
        dataField: "browserName",
        text: "Browser Name",
      },
      {
        dataField: "percentage",
        text: "Percentage",
        formatter: percentageFormatter,
      },
    ];

    const countryLogsColumns = [
      {
        dataField: "country_name",
        text: "Country Name",
      },
      {
        dataField: "percentage",
        text: "Percentage",
        formatter: percentageFormatter,
      },
    ];

    const pageLogsColumns = [
      {
        dataField: "publish_start",
        text: "Live From",
        formatter: dateFormatter,
      },
      {
        dataField: "publish_end",
        text: "Live To",
        formatter: dateFormatter,
      },
      {
        dataField: "postUid",
        text: "PostUid",
      },
      {
        dataField: "title",
        text: "Post Title",
        sort: true,
      },
      {
        dataField: "pageType",
        text: "Page Type",
        sort: true,
      },
      {
        dataField: "visit_count",
        text: "Visited Count",
        sort: true,
      },
    ];

    const columns = [
      {
        dataField: "users_username",
        text: "User Id",
        sort: true,
      },
      {
        dataField: "pageType",
        text: "Page Name",
        sort: true,
      },
      {
        dataField: "ip_address",
        text: "Ip Address",
      },
      {
        dataField: "pageId",
        text: "Page Id",
        sort: true,
      },
      {
        dataField: "osName",
        text: "OS Name",
        sort: true,
      },
      {
        dataField: "browserName",
        text: "Browser",
        sort: true,
      },
      {
        dataField: "visited_at",
        text: "Visited Date",
        formatter: dateFormatter,
        sort: true,
      },
    ];

    const defaultSorted = [
      {
        dataField: "visited_at",
        order: "desc",
      },
    ];

    const osLogsList = osLogs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="id"
          wrapperClasses="table-responsive"
          data={osLogs}
          loading={true}
          columns={osLogsColumns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    const browserLogsList = browserLogs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="id"
          wrapperClasses="table-responsive"
          data={browserLogs}
          loading={true}
          columns={browserLogsColumns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    const countryLogsList = countryLogs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="id"
          wrapperClasses="table-responsive"
          data={countryLogs}
          loading={true}
          columns={countryLogsColumns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    const webLogsList = userLogs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="weblogsUid"
          wrapperClasses="table-responsive"
          data={userLogs}
          loading={true}
          columns={columns}
          defaultSorted={defaultSorted}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    const pageLogsList = pageLogs && (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="weblogsUid"
          wrapperClasses="table-responsive"
          data={pageLogs}
          loading={true}
          columns={pageLogsColumns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );

    return (
      <div>
        <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
          <h1>WEB LOGS</h1>
        </div>
        <div id="accordion" className="pt-3">
          <div className="card">
            <div
              className="card-header"
              id="headingOne"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              onClick={this.onClickAccordion.bind(this, "platform_logs")}
            >
              <h2 className="mb-0">Platform Logs</h2>
            </div>
            <div
              id="collapseOne"
              className="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="filters mb-2">
                  <form ref={(el) => (this.myFormRef = el)}>
                    <h2>Filters</h2>
                    <div className="brd-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">From Date</p>
                              <DatePicker
                                className="form-control"
                                dateFormat="MMMM d, yyyy"
                                selected={
                                  this.state.filterData.platform_logs
                                    .visit_from_date
                                }
                                onChange={(date) =>
                                  this.handleDateChange(
                                    date,
                                    "visit_from_date",
                                    "platform_logs"
                                  )
                                }
                              />
                              <div className="errorMsg">
                                {
                                  this.state.errors.platform_logs[
                                    "visit_from_date"
                                  ]
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">To Date</p>
                              <DatePicker
                                className="form-control"
                                dateFormat="MMMM d, yyyy"
                                selected={
                                  this.state.filterData.platform_logs
                                    .visit_to_date
                                }
                                onChange={(date) =>
                                  this.handleDateChange(
                                    date,
                                    "visit_to_date",
                                    "platform_logs"
                                  )
                                }
                              />
                              <div className="errorMsg">
                                {
                                  this.state.errors.platform_logs[
                                    "visit_to_date"
                                  ]
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between pt-1 flex-column flex-lg-row">
                      <div className="">
                        <button
                          className="btn-secondary filter-btn"
                          onClick={this.onReset.bind(this, "platform_logs")}
                        >
                          Reset
                        </button>
                        <button
                          className="btn-secondary filter-btn"
                          onClick={this.onFilter.bind(this, "platform_logs")}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                {osLogsList}
                {browserLogsList}
                {countryLogsList}
                {/* <table className="table">
                          <thead className="thead-dark">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">First</th>
                              <th scope="col">Last</th>
                              <th scope="col">Handle</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th scope="row">1</th>
                              <td>Mark</td>
                              <td>Otto</td>
                              <td>@mdo</td>
                            </tr>
                            <tr>
                              <th scope="row">2</th>
                              <td>Jacob</td>
                              <td>Thornton</td>
                              <td>@fat</td>
                            </tr>
                            <tr>
                              <th scope="row">3</th>
                              <td>Larry</td>
                              <td>the Bird</td>
                              <td>@twitter</td>
                            </tr>
                          </tbody>
                        </table> */}
              </div>
            </div>
          </div>
          <div className="card">
            <div
              className="card-header collapsed"
              id="headingTwo"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
              onClick={this.onClickAccordion.bind(this, "page_logs")}
            >
              <h2 className="mb-0">Page Logs</h2>
            </div>
            <div
              id="collapseTwo"
              className="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="filters mb-2">
                  <form ref={(el) => (this.myFormRef = el)}>
                    <h2>Filters</h2>
                    <div className="brd-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">From Date</p>
                              <DatePicker
                                className="form-control"
                                dateFormat="MMMM d, yyyy"
                                selected={
                                  this.state.filterData.page_logs
                                    .visit_from_date
                                }
                                onChange={(date) =>
                                  this.handleDateChange(
                                    date,
                                    "visit_from_date",
                                    "page_logs"
                                  )
                                }
                              />
                              <div className="errorMsg">
                                {this.state.errors.page_logs["visit_from_date"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">To Date</p>
                              <DatePicker
                                className="form-control"
                                dateFormat="MMMM d, yyyy"
                                selected={
                                  this.state.filterData.page_logs.visit_to_date
                                }
                                onChange={(date) =>
                                  this.handleDateChange(
                                    date,
                                    "visit_to_date",
                                    "page_logs"
                                  )
                                }
                              />
                              <div className="errorMsg">
                                {this.state.errors.page_logs["visit_to_date"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">Post Title</p>
                              <input
                                name="title"
                                type="text"
                                onChange={this.onInputChange.bind(
                                  this,
                                  "page_logs"
                                )}
                                value={
                                  this.state.filterData.page_logs.title || ""
                                }
                                className="form-control"
                              />
                              <div className="errorMsg">
                                {this.state.errors.page_logs["title"]}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between pt-1 flex-column flex-lg-row">
                      <div className="">
                        <button
                          className="btn-secondary filter-btn"
                          onClick={this.onReset.bind(this, "page_logs")}
                        >
                          Reset
                        </button>
                        <button
                          className="btn-secondary filter-btn"
                          onClick={this.onFilter.bind(this, "page_logs")}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                {pageLogsList}
                <hr></hr>
                <div className="d-flex align-items-center">
                  <label className="m-r-5">EXPORT TO</label>
                  <ExportXlsxCsv
                    Data={this.state.pageLogsCsvData}
                    fileName="page-logs"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div
              className="card-header collapsed"
              id="headingThree"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
              onClick={this.onClickAccordion.bind(this, "users_logs")}
            >
              <h2 className="mb-0">Users Logs</h2>
            </div>
            <div
              id="collapseThree"
              className="collapse"
              aria-labelledby="headingThree"
              data-parent="#accordion"
            >
              <div className="card-body">
                <div className="filters mb-2">
                  <form ref={(el) => (this.myFormRef = el)}>
                    <h2>Filters</h2>
                    <div className="brd-1">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">From Date</p>
                              <DatePicker
                                className="form-control"
                                dateFormat="MMMM d, yyyy"
                                selected={
                                  this.state.filterData.users_logs
                                    .visit_from_date
                                }
                                onChange={(date) =>
                                  this.handleDateChange(
                                    date,
                                    "visit_from_date",
                                    "users_logs"
                                  )
                                }
                              />
                              <div className="errorMsg">
                                {
                                  this.state.errors.users_logs[
                                    "visit_from_date"
                                  ]
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">To Date</p>
                              <DatePicker
                                className="form-control"
                                dateFormat="MMMM d, yyyy"
                                selected={
                                  this.state.filterData.users_logs.visit_to_date
                                }
                                onChange={(date) =>
                                  this.handleDateChange(
                                    date,
                                    "visit_to_date",
                                    "users_logs"
                                  )
                                }
                              />
                              <div className="errorMsg">
                                {this.state.errors.users_logs["visit_to_date"]}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="date d-flex align-items-center pb-2">
                            <div className="date">
                              <p className="datetext">User Id</p>
                              <input
                                name="users_userid"
                                type="text"
                                onChange={this.onInputChange.bind(
                                  this,
                                  "users_logs"
                                )}
                                value={
                                  this.state.filterData.users_logs
                                    .users_userid || ""
                                }
                                className="form-control"
                              />
                              <div className="errorMsg">
                                {this.state.errors.page_logs["users_userid"]}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between pt-1 flex-column flex-lg-row">
                      <div className="">
                        <button
                          className="btn-secondary filter-btn"
                          onClick={this.onReset.bind(this, "users_logs")}
                        >
                          Reset
                        </button>
                        <button
                          className="btn-secondary filter-btn"
                          onClick={this.onFilter.bind(this, "users_logs")}
                        >
                          Filter
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                {webLogsList}
              </div>
            </div>
          </div>
        </div>
        {this.props.webLogsActionLoading === true && (
          <div className="sweet-loading">
            <GridLoader
              css={override}
              sizeUnit={"px"}
              size={40}
              color={"#cadb2a"}
              loading={this.props.webLogsActionLoading}
            />
          </div>
        )}
        <div className="overlay"></div>
      </div>
    );
  }
}

function dateFormatter(cell, row) {
  // console.log("Cell........", cell);
  if (cell) {
    if (cell === "UNPUBLISHED" || cell === "INDEFINITE") {
      return cell;
    } else {
      return moment(cell).format("YYYY-MM-DD hh:mm a");
    }
  } else {
    return "";
  }
}

function percentageFormatter(cell, row) {
  if (cell) {
    return cell + "%";
  } else {
    return "";
  }
}

function indication() {
  return "No records found!";
}
/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  // console.log("State ==========", state);
  return {
    webLogsActionLoading: state.weblogs.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    osLogs: state.weblogs.platformLogs["os_logs"]
      ? Object.values(state.weblogs.platformLogs["os_logs"])
      : [],
    browserLogs: state.weblogs.platformLogs["browser_logs"]
      ? Object.values(state.weblogs.platformLogs["browser_logs"])
      : [],
    countryLogs: state.weblogs.platformLogs["country_logs"]
      ? Object.values(state.weblogs.platformLogs["country_logs"])
      : [],
    pageLogs: Object.values(state.weblogs.pageLogs),
    userLogs: Object.values(state.weblogs.userLogs),
  };
}
/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(webLogsActions, dispatch)
)(WebLogs);
